export default ({ className = '', onNav, query = '' }) => {
  return (
    <Link className={className} to={`/dodones/today${query}`} onClick={onNav}>
      Today
    </Link>
  )
}
